<template>
    <button @click="action_SelectStatus">
        <span class="color_square" :style="styleString"></span>
        <span class="txt ellipsis">{{ title }}</span>
    </button>
</template>


<script>
import { sheetState } from '../../../sheet-state'

export default {
    props: {
        status: Object
    },
    data() {
        return {
            sheetState,
        }
    },
    computed: {
        title: function() {
            return this.status.title
        },
        styleString: function() {
            return 'background-color: ' + this.colorHex + ';'
        },

        reservationSetting: function() {
            return this.sheetState.reservationSetting
        },
        colorPalette: function() {
            return this.reservationSetting?.statusColorPaletteID?.basicPalette ?? []
        },
        colorIndex: function() {
            return this.status.paletteIndex
        },
        colorHex: function() {
            if (this.colorPalette.length == 0) { return '#000000'}
            return this.colorPalette[this.colorIndex]
        }
    },
    methods: {
        action_SelectStatus() {
            this.$emit('selectStatus', this.status)
        }
    }
}
</script>